<template>
    <OverlayLoader :isLoading="!resellersLoaded">
        <main class="page page-dashboard">
            <div class="container">

                <PageHeader
                    :title="$translate.text('general.dashboard')"
                    icon="fal fa-search"
                    @catchEmit="toggleSearch"
                />

                <AdminResellersBlocks
                    :resellers="resellers"
                    @reloadResellers="reloadResellers"
                    @deleteReseller="deleteReseller"
                    @deactivateReseller="deactivateReseller"
                    @activateReseller="activateReseller"
                />
            </div>

            <FloatingButton
                @clicked="$router.push({ name: 'Admin Resellers Add' })"
            />
        </main>
    </OverlayLoader>
</template>
<script>
import { get, remove, post } from '@/helpers/http';
import handleError from '@/helpers/error';

import PageHeader from '@/components/PageHeader/PageHeader';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import AdminResellersBlocks from '@/components/AdminResellersBlocks/AdminResellersBlocks';
import FloatingButton from '@/components/FloatingButton/FloatingButton';

export default {
    name: 'AdminResellers',

    components: {
        PageHeader,
        OverlayLoader,
        AdminResellersBlocks,
        FloatingButton,
    },

    data() {
        return {
            resellers: [],
            resellersLoaded: false,

            filters: {
                search: null,
            },
        };
    },

    created() {
        this.getResellers();
    },

    methods: {
        toggleSearch(event) {
            if (event === '') {
                event = null;
            }

            this.filters.search = event;
            this.getResellers();
        },

        getResellers() {
            let search = '';
            if (this.filters.search !== null) {
                search = `&search=${this.filters.search}`;
            }
            get({
                url: `${this.$API_URL}/api/admin/resellers?paginate=1000${search}`,
            })
                .then((response) => {
                    this.resellers = response.data.data;
                    this.resellersLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        reloadResellers() {
            this.getResellers();
        },

        deleteReseller(id) {
            remove({
                url: `${this.$API_URL}/api/admin/resellers/${id}`,
            })
                .then(() => this.getResellers())
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        deactivateReseller(id) {
            post({
                url: `${this.$API_URL}/api/admin/resellers/${id}/status`,
                data: {
                    active: 0,
                },
            })
                .then(() => this.getResellers())
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        activateReseller(id) {
            post({
                url: `${this.$API_URL}/api/admin/resellers/${id}/status`,
                data: {
                    active: 1,
                },
            })
                .then(() => this.getResellers())
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

    },
};
</script>
<style lang="scss" scoped>
</style>
